import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';

var useStyles = makeStyles({
  mapFrame: {
    width: "100%",
    height: "100%"
  }
});
var IframeMap = function IframeMap(_ref) {
  var url = _ref.url,
    keyword = _ref.keyword,
    coordinates = _ref.coordinates,
    placeId = _ref.placeId,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  var classes = useStyles();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  useEffect(function () {
    if (placeId) {
      setQuery("&q=place_id:".concat(placeId));
    } else if (keyword) {
      setQuery("&q=".concat(keyword));
    } else if (coordinates) {
      setQuery("&q=".concat(coordinates.lat, ",").concat(coordinates.lon));
    }
  }, [coordinates, placeId, keyword]);
  return /*#__PURE__*/React__default.createElement(Box, {
    className: className || "",
    width: width || "100%",
    height: height || 450
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: classes.mapFrame,
    frameBorder: 0,
    src: "".concat(url).concat(query)
  }));
};
IframeMap.propTypes = {
  url: PropTypes__default.string.isRequired,
  keyword: PropTypes__default.string,
  width: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  height: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  placeId: PropTypes__default.string,
  coordinates: PropTypes__default.shape({
    lon: PropTypes__default.number,
    lat: PropTypes__default.number
  }),
  className: PropTypes__default.any
};

export { IframeMap as default };
//# sourceMappingURL=IframeMap.js.map
